import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData, ConfirmDialogResult, SuccessDialogData } from '../../core/utils/dialog.models';

@Component({
	selector: 'confirm-dialog',
	templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements OnInit {
	public title: string;
	public text: string;
	public okBtnText: string;
	public cancelBtnText: string;

	public constructor(
		public dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
	) {}

	public ngOnInit(): void {
		this.title = this.data.title;
		this.text = this.data.text;
		this.okBtnText = this.data.okBtnText;
		this.cancelBtnText = this.data.cancelBtnText;
	}

	public onOkClick(): void {
		this.dialogRef.close({ confirm: true });
	}

	public onCancelClick(): void {
		this.dialogRef.close({ confirm: false });
	}
}
